module.exports = __webpack_public_path__ + "static/media/dig-our-way-out.594dab99.png";